export default "__VITE_ASSET__DqwKgX5u__"